import { Button, Drawer, Form, Input, message, Popover, Space } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import fetchDataArps from "../../../services/fetchDataArps";
import patchDataArps from "../../../services/patchDataArps";
import { useSendEmailMutation } from "../../../store/endpoints/email/email";
import formatMoney from "../../../utils/formatMoney";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../../utils/XLSXExport";

const { Search } = Input;
export default function AssetsPanel({
  isVisible,
  setVisible,
  assets,
  title,
  year,
  center,
  refetch,
}: any) {
  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState<any>([]);
  const [category, setCategory] = useState<any>("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);

  const [emailForm] = Form.useForm();
  const [form] = Form.useForm();

  const sendMail = async (values: any) => {
    const data = assets?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Date: moment(record?.posting_date.toString()).format("Do MMM YYYY"),
        Description: record?.description ? record?.description : "-",

        Narrative: record?.narrative ? record?.narrative : "-",
        Department: record?.department ? record?.department : "-",
        "Cost Center": record?.cost_center ? record?.cost_center : "-",
        Origin: record?.origin ? record?.origin : "-",
        Shortname: record?.shortname ? record?.shortname : "-",
        "Expense Code": record?.expense_code ? record?.expense_code : "-",
        "Journal Reference": record?.journal_reference
          ? record?.journal_reference
          : "-",
        Amount: record?.base_value ? record?.base_value : "-",
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  const handleFetchMetadata = async () => {
    const uri = "assets/metadata";
    const response = await fetchDataArps(uri);
    const cats = response?.payload?.categories?.map(function (value: any) {
      return { name: value };
    });
    setCategories(cats);
  };

  const handleUpdateAsset = async (item: any) => {
    setLoading(true);
    if (category) {
      const uri = `assets/${item?._id}`;
      const data = { asset_class: category };
      const response = await patchDataArps(data, uri);
      if (response?.success) {
        message.success("Updated successfully");
        await refetch();
      } else {
        message.error("Something went wrong");
      }
    } else {
      message.error("Please select one of the options");
    }
    setLoading(false);
  };

  const getTotal = () => {
    let total = 0;

    assets
      ?.filter((expense: any) => expense?.description?.includes(search))
      ?.forEach((item: any) => {
        total = total + item?.tsh_amount * item?.quantity;
      });
    return isNaN(total) ? 0 : total;
  };

  useEffect(() => {
    handleFetchMetadata();
  }, []);
  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">
            <span className="font-bold mr-2">{title || "Miscellaneous"}</span>:
          </span>
          {year} - [ {center?.name} ]
        </div>
      }
      placement={"right"}
      width={900}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by description"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex flex-row">
            <Popover
              content={
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    form={emailForm}
                    onFinish={sendMail}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: "Email is Required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        { required: true, message: "Subject is Required" },
                      ]}
                    >
                      <Input placeholder="Email Subject" />
                    </Form.Item>
                    <div className="flex flex-row justify-between">
                      <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                        <Button
                          onClick={() => {
                            toggleMessageModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </>
              }
              title="Message Content"
              trigger="focus"
              placement="left"
              visible={messageModal}
            >
              <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                <RiMailSendLine size={21} />
                <span
                  className="ml-2"
                  onClick={async () => {
                    toggleMessageModal(true);
                  }}
                >
                  Send Email
                </span>
              </button>
            </Popover>
            <button
              color="#E50000"
              className="flex ml-4 justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={async () => {
                  message.success("Exporting ...");
                  const data = assets?.map((record: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      Year: record?.year,
                      Description: record?.description
                        ? record?.description
                        : "-",

                      Supplier: record?.supplier ? record?.supplier : "-",
                      "LPO Number": record?.lpo_no ? record?.lpo_no : "-",
                      Quantity: record?.quantity ? record?.quantity : "-",
                      "Asset Class": record?.asset_class
                        ? record?.asset_class
                        : "-",
                      "Unit Price": record?.tsh_amount
                        ? record?.tsh_amountx
                        : "-",

                      "Sub Total": record?.tsh_amount
                        ? record?.tsh_amount * record?.quantity
                        : "-",
                    };
                  });
                  ExportToExcel(data, "Assets.xlsx");
                }}
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex">
              <div className="w-12 font-bold">Year</div>
              <div className="w-52 truncate text-left font-bold">
                Description
              </div>
              <div className="w-14 truncate text-left font-bold">LPO</div>
              <div className="w-32 truncate text-left font-bold">Supplier</div>
              <div className="w-32 truncate text-left font-bold">
                Asset Class
              </div>
              <div className="w-10 truncate font-bold text-left">Qty</div>
              <div className="w-20 truncate font-bold">Unit Price</div>
            </div>
            <div className="flex font-bold">
              <div className="">Amount</div>
              <div className="w-12 text-right">Edit</div>
            </div>
          </div>
        </div>
        {assets
          ?.filter((expense: any) => expense?.description?.includes(search))
          ?.map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 flex justify-center items-center">
                {index + 1}.
              </div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex">
                  <div className="w-12">{item?.year ? item?.year : "-"}</div>
                  <div className="w-52 truncate text-left">
                    {item?.description ? item?.description : "-"}
                  </div>
                  <div className="w-14 truncate text-left">
                    {item?.lpo_no ? item?.lpo_no : "-"}
                  </div>
                  <div className="w-32 truncate text-left">
                    {item?.supplier ? item?.supplier : "-"}
                  </div>
                  <div className="w-32 truncate text-left">
                    {item?.asset_class ? item?.asset_class : "-"}
                  </div>
                  <div className="w-10 truncate">
                    {item.quantity ? item.quantity : "-"}
                  </div>
                  <div className="w-20 truncate">
                    {item.price ? formatMoney(item.price) : "-"}
                  </div>
                </div>
                <div className="flex">
                  <div className="">
                    {formatMoney(
                      item?.tsh_amount
                        ? Number(item?.tsh_amount * item?.quantity)
                        : 0
                    )}
                  </div>

                  <Popover
                    content={
                      <div className="flex justify-center items-center">
                        <select
                          placeholder="Select asset class"
                          onChange={(e) => setCategory(e.target.value)}
                          name="Asset Class"
                          className="border py-1"
                        >
                          {categories?.map((item: any) => (
                            <option value={item?.name}>{item?.name}</option>
                          ))}
                        </select>
                        <button
                          onClick={() => {
                            handleUpdateAsset(item);
                            setOpen(false);
                          }}
                          className="border border-green-500 px-2 ml-1 bg-green-500 text-white"
                        >
                          {isLoading ? ".........." : "Update"}
                        </button>
                      </div>
                    }
                    placement="bottom"
                    title={`${item?.description} - ${item?.year}`}
                    trigger="click"
                  >
                    <button className="truncate ml-2 border p-2 flex justify-end bg-yellow-50">
                      <FiEdit color="black" />
                    </button>
                  </Popover>
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="">Grand Total</div>
          <div className="font-bold">{formatMoney(getTotal())}</div>
        </div>
      </div>
    </Drawer>
  );
}
